import { Button } from 'components/common/button/button';
import { useModal } from 'components/modal-views/context';

import { STEPS } from 'lib/constants';
import { getStep } from 'utils';
import { parseTokenAmount } from 'utils/amounts';

const RetireCardButton = ({
  clearSelectedProjects,
  selected,
  sum,
  name,
  state
}) => {
  const { openModal } = useModal();
  const [step, setStep] = state;

  const isDisabled = () => {
    if (step === STEPS.CHOOSE_PROJECTS) {
      return Object.keys(selected).length === 0;
    }

    if (step === STEPS.ENTER_AMOUNT) {
      return selected.some(
        (item) =>
          item.error !== '' || item.value === '' || Number(item.value) === 0
      );
    }

    if (step === STEPS.ENTER_RECIPIENT) {
      return name === '';
    }
  };

  const onClickHandler = () => {
    return step !== STEPS.ENTER_RECIPIENT
      ? setStep(getStep(step, +1, STEPS))
      : openModal(
          'RETIRE_VIEW',
          sum,
          selected.map((item) => [
            item.project_id,
            parseTokenAmount(item.value)
          ]),
          () => {
            setStep(STEPS.CHOOSE_PROJECTS);
            clearSelectedProjects();
          },
          name
        );
  };

  return (
    <Button
      fullwidth
      size="middle"
      disabled={isDisabled()}
      onClick={onClickHandler}
    >
      {step === STEPS.ENTER_RECIPIENT ? 'Retire' : 'Continue'}
    </Button>
  );
};

export default RetireCardButton;
